import { initializeApp } from "firebase/app";
import { getFirestore, collection, query, where, onSnapshot } from "firebase/firestore";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
    apiKey: "AIzaSyBRRDLs9GfHwKyeYlMEzNW-HpA1QizM4bg",
    authDomain: "pmc-cskh.firebaseapp.com",
    projectId: "pmc-cskh",
    storageBucket: "pmc-cskh.firebasestorage.app",
    messagingSenderId: "424861355345",
    appId: "1:424861355345:web:25e64cc4a684fb8f5bd770",
    measurementId: "G-Y1NB6WNNJH"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const messaging = getMessaging(app);
export { db,messaging };
